import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEqual, sortBy } from 'lodash';
import { Stack, Button, Typography } from '@metarouter-private/mr-mui';
import { useUpdateWebhookConfig } from '@ion/api';
import EventTypeCheckboxes from './EventTypeCheckboxes';

export default function EditEventTypes({ webhookConfig }) {
  const subscriptions = webhookConfig.webhookConfigEventSubscriptions;
  const currentTypes = subscriptions.map(sub => sub.eventType);
  const [selectedTypes, setSelectedTypes] = useState(currentTypes);
  const [updateConfig, { loading }] = useUpdateWebhookConfig();

  const hasChanges = !isEqual(sortBy(selectedTypes), sortBy(currentTypes));

  const handleSave = () => {
    updateConfig({ webhookConfigId: webhookConfig.id, eventTypes: selectedTypes });
  };

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2" color="text.secondary">
        Subscribed Events
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Select which events should trigger this webhook.
      </Typography>
      <EventTypeCheckboxes selectedTypes={selectedTypes} onChange={setSelectedTypes} />
      {hasChanges && (
        <Stack direction="row" justifyContent="flex-end">
          <Button
            variant="contained"
            size="small"
            onClick={handleSave}
            disabled={loading || selectedTypes.length === 0}
          >
            {loading ? 'Saving...' : 'Save Changes'}
          </Button>
        </Stack>
      )}
    </Stack>
  );
}

EditEventTypes.propTypes = {
  webhookConfig: PropTypes.shape({
    id: PropTypes.string.isRequired,
    webhookConfigEventSubscriptions: PropTypes.arrayOf(
      PropTypes.shape({
        eventType: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};
